import Vue from 'vue';

const { $gettext } = Vue.prototype;

export default {
  attributes: {
    /* Article */
    category: $gettext('Article Group'),
    name: $gettext('Name'),
    productGroup: $gettext('Product Group'),
    orderLevel: $gettext('Order Level'),
    price: $gettext('Price'),
    priceMax: $gettext('Price Max'),
    priceMin: $gettext('Price Min'),
    quantity: $gettext('Quantity'),
    type: $gettext('Article Type'),

    /* Stock Item */
    cost: $gettext('Buying Price'),
    size: $gettext('Size'),
    unit: $gettext('Unit'),
    managementGroup: $gettext('Management Group'),
    count: $gettext('Count'),
    alarmLevel: $gettext('Alarm Level'),
    standardOrder: $gettext('Reorder'),
    stockItemId: $gettext('Stock Item'),
    stockItemName: $gettext('Item Name'),

    /* Promotion */
    promotionType: $gettext('Promotion Type'),
    value: $gettext('Value'),
    subValue: $gettext('Sub Value'),
    fromDate: $gettext('From'),
    toDate: $gettext('To'),
    startTime: $gettext('Start Time'),
    endTime: $gettext('End Time'),
    dayOfWeek: $gettext('Day of week'),
  },
  messages: {
    decimal: (field) => {
      const fieldName = field.includes('quantity') ? 'Quantity' : field;
      return `${fieldName} is invalid`;
    },
    max_value: (field, [value]) => {
      const fieldName = field.includes('quantity') ? 'Quantity' : field;
      return `${fieldName} must be less than ${value}`;
    },
    numeric: (field) => {
      const fieldName = field.includes('quantity') ? 'Quantity' : field;
      return $gettext(fieldName) + ' ' + $gettext('is invalid');
    },
    required: field => $gettext('Please, enter ') + (field.includes('location') ? 'location' : (field.includes('station') ? 'station' : $gettext(field))),
    required_if: field => $gettext('Please, enter') + ' ' + $gettext(field),
  },
};
